/**
 * Postcard QR attribution helper. Single source of truth for the
 * localStorage key + shape, used by:
 *   - /qr/:slug page (writes on scan)
 *   - Home page (writes on `?qr=` URL param fallback, reads to show banner)
 *   - api.js axios interceptor (reads to attach `X-QR-Slug` header)
 *
 * Shape: { slug, code, scanned_at, expires_at }
 * Expires after 30 days — long enough for a postcard recipient to scan
 * today and convert weeks later, short enough that we're not stamping
 * old attribution on every future order forever.
 */
const KEY = 'tal_qr_attribution';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function saveQrAttribution({ slug, code }) {
  if (!slug) return null;
  const now = Date.now();
  const rec = {
    slug: String(slug).toLowerCase(),
    code: code || null,
    scanned_at: new Date(now).toISOString(),
    expires_at: new Date(now + TTL_MS).toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(rec));
  } catch (_) {}
  return rec;
}

export function getQrAttribution() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw);
    if (!rec || !rec.slug) return null;
    if (rec.expires_at && Date.now() > Date.parse(rec.expires_at)) {
      localStorage.removeItem(KEY);
      return null;
    }
    return rec;
  } catch (_) {
    return null;
  }
}

export function clearQrAttribution() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}
